// ANCHOR Model
import createModel, { createSelector } from 'react-scoped-model';

// ANCHOR SWR
import useSWR from 'swr';

// ANCHOR API
import { getProviderCourses } from '@lyon/utils/api/provider';

interface IProps {
  id: string;
}

export const ProviderCourseData = createModel(
  ({ id }: IProps) => {
    const response = useSWR(
      `/provider/${id}/courses`,
      () => getProviderCourses(id),
    );

    return {
      ...response,
    };
  },
  {
    displayName: 'Models.ProviderCourseData',
  },
);

export const useProviderCourseData = createSelector(
  ProviderCourseData,
  ({ data }) => data,
);

export const useProviderCourseMutate = createSelector(
  ProviderCourseData,
  ({ mutate }) => mutate,
);

export const useProviderCourseError = createSelector(
  ProviderCourseData,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  ({ error }) => error,
);
